/**
 * Aspect — Resize/compress floor-plan uploads before sending to the orchestrator.
 * Large PNG screenshots can be 5–15 MB and slow both upload and vision API calls.
 */

/** @param {string} dataUrl @param {number} [maxDim] @param {number} [quality] */
export function compressImageDataUrl(dataUrl, maxDim = 1600, quality = 0.82) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxDim / Math.max(img.width, img.height, 1));
      const w = Math.max(1, Math.round(img.width * scale));
      const h = Math.max(1, Math.round(img.height * scale));
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        resolve(dataUrl);
        return;
      }
      ctx.drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL("image/jpeg", quality));
    };
    img.onerror = () => reject(new Error("Could not read the image file."));
    img.src = dataUrl;
  });
}

export default compressImageDataUrl;
